import { createReducer } from 'immutable-reducers';
import { userRoles } from 'app/access';
import { List } from 'immutable';
import jwtDecode from 'jwt-decode';

import * as authActionTypes from 'modules/auth/constants/actionTypes';
import * as actionTypes from '../constants/actionTypes';

export default createReducer(['licensePlates'], (licensePlates = {}, action) => {
    let payload = action.payload;

    switch (action.type) {
        case authActionTypes.LOGIN:
            return List.of('1-ABC-123', '123-ABC', 'ABC-123'); //TODO: should be payload data
            //return List.of(...payload.profile.licensePlates);
        case authActionTypes.LOGOUT:
            return List.of();
        default:
            break;
    }
    return licensePlates;
});
